import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Info, UsersRound } from 'lucide-react';

import { useHasPermission } from '@/lib/permissions';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import { ApiKeysTab } from '@/components/settings/ApiKeysTab';
import { BillingTab } from '@/components/settings/BillingTab';
import { TenantSettingsCard } from '@/components/settings/TenantSettingsCard';
import { WebhooksTab } from '@/components/settings/WebhooksTab';

export const Route = createFileRoute('/_authed/settings')({ component: SettingsPage });

export function SettingsPage() {
  const navigate = useNavigate();
  const canReadUsers = useHasPermission('users.read');
  // Réservé à OWNER / ADMIN : sans la permission, ni onglets ni requêtes (le 403 s'affichait « Aucune clé API »)
  const canIntegrations = useHasPermission('integrations.read');
  // Abonnement SaaS : OWNER, ADMIN, ACCOUNTANT (billing.read)
  const canBilling = useHasPermission('billing.read');

  return (
    <div className="p-6 space-y-4">
      <h1 className="text-2xl font-bold">Paramètres</h1>
      <Tabs defaultValue="tenant">
        <TabsList>
          <TabsTrigger value="tenant">Tenant</TabsTrigger>
          <TabsTrigger value="users">Utilisateurs</TabsTrigger>
          {canIntegrations && <TabsTrigger value="apikeys">Clés API</TabsTrigger>}
          {canIntegrations && <TabsTrigger value="webhooks">Webhooks</TabsTrigger>}
          {canBilling && <TabsTrigger value="billing">Abonnement</TabsTrigger>}
        </TabsList>

        <TabsContent value="tenant">
          <TenantSettingsCard />
        </TabsContent>

        <TabsContent value="users">
          <Card>
            <CardHeader><CardTitle>Gestion des utilisateurs</CardTitle></CardHeader>
            {/* Membres, invitations et rôles vivent sur /team : pas de seconde liste ici */}
            <CardContent className="flex flex-wrap items-center gap-4">
              <p className="flex flex-1 items-start gap-2 text-sm text-muted-foreground">
                <Info className="h-4 w-4 mt-0.5 shrink-0" />
                Les membres, les invitations en attente et les permissions par rôle se gèrent depuis la page Équipe.
              </p>
              {canReadUsers && (
                <Button onClick={() => void navigate({ to: '/team' })}>
                  <UsersRound className="h-4 w-4 mr-2" /> Gérer les membres
                </Button>
              )}
            </CardContent>
          </Card>
        </TabsContent>

        {canIntegrations && (
          <TabsContent value="apikeys">
            <ApiKeysTab />
          </TabsContent>
        )}

        {canIntegrations && (
          <TabsContent value="webhooks">
            <WebhooksTab />
          </TabsContent>
        )}

        {canBilling && (
          <TabsContent value="billing">
            <BillingTab />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
}
